class WebSocketService {
  constructor() {
    this.socket = null
    this.eventHandlers = {}
    this.messageListeners = new Set()
    this.userID = null
    this.shouldReconnect = false
    this.reconnectTimer = null
  }

  isActive() {
    return (
      !!this.socket &&
      (this.socket.readyState === WebSocket.OPEN ||
        this.socket.readyState === WebSocket.CONNECTING)
    )
  }

  connect(userID) {
    if (!userID) return

    if (this.isActive() && this.userID === userID) return

    this.userID = userID
    this.shouldReconnect = true
    this.cleanupSocket()

    const WS_ENDPOINT = `wss://igocqr11r9.execute-api.us-east-1.amazonaws.com/dev?userID=${userID}`
    const socket = new WebSocket(WS_ENDPOINT)
    this.socket = socket

    socket.addEventListener('message', (event) => {
      this.dispatchMessage(event)
    })

    socket.addEventListener('close', () => {
      if (this.socket !== socket) return

      this.socket = null
      if (!this.shouldReconnect || !this.userID) return

      this.reconnectTimer = setTimeout(() => {
        this.connect(this.userID)
      }, 2000)
    })
  }

  dispatchMessage(event) {
    try {
      const message = JSON.parse(event.data)
      if (this.eventHandlers[message.event]) {
        this.eventHandlers[message.event](message)
      }
    } catch (err) {
      // Non-JSON frames are still forwarded to listeners.
    }

    this.messageListeners.forEach((handler) => {
      try {
        handler(event)
      } catch (err) {
        console.error('WebSocket listener error', err)
      }
    })
  }

  addMessageListener(handler) {
    this.messageListeners.add(handler)
    return () => {
      this.messageListeners.delete(handler)
    }
  }

  sendMessage(data) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(data))
    }
  }

  on(event, handler) {
    this.eventHandlers[event] = handler
  }

  cleanupSocket() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer)
      this.reconnectTimer = null
    }

    if (!this.socket) return

    const socket = this.socket
    this.socket = null

    try {
      socket.close()
    } catch (err) {
      // Socket may already be closing.
    }
  }

  disconnect(userID) {
    this.shouldReconnect = false
    this.sendMessage({ action: 'disconnect', userID: userID || this.userID })
    this.cleanupSocket()
  }
}

export const webSocketService = new WebSocketService()
